<div class="form-title">
    <p [innerHtml]='"gblSorryYouMustBe16" | translate'></p>
</div>
<div class="form-group">
    <button class="btn btn-primary w-100" [routerLink]="['/login']">{{"gblReturnToLogin" | translate}}</button>
</div>